import { z } from 'zod';

import { BorrowerId, PropertyId } from '../BrandedIds';
import { zodDateOrString } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreateRequestedPayoffEvent = BaseLoanEvent.extend({
  type: z.literal('createRequestedPayoff'),
  payoffDate: zodDateOrString,
  additionalBorrowers: z.array(BorrowerId),
  propertyIds: z.array(PropertyId).optional(),
  message: z.string().optional(),
});
export type CreateRequestedPayoffEvent = z.infer<typeof CreateRequestedPayoffEvent>;
